import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import commonProps from './common/common-props';
import SignUpPane from './sign-up-elements/sign-up-pane';
import LivewireBrand from './common/livewire-brand';
import { Page } from './common/styles';

export default function SignUp(props) {
  const state = {
    ...props,
    ...commonProps(),
  };

  return (
    <ThemeProvider theme={state}>
      <Page>
        <LivewireBrand />
        <SignUpPane />
      </Page>
    </ThemeProvider>
  );
}

/* eslint-disable react/no-unused-prop-types */
SignUp.propTypes = {
  logo: PropTypes.string.isRequired,
  redirectTo: PropTypes.string.isRequired,
  linkedInLogo: PropTypes.string.isRequired,
  linkedInAuthorizeUrl: PropTypes.string.isRequired,
};
/* eslint-enable react/no-unused-prop-types */
